import { render, staticRenderFns } from "./TnyWeaponSelector.vue?vue&type=template&id=23ac1fcd&"
import script from "./TnyWeaponSelector.vue?vue&type=script&lang=ts&"
export * from "./TnyWeaponSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TnyWeaponSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports